import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        showFilter: '=',
        view: '=',
        list: '=',
        classifiers: '=',
        defaultFilter: '=',
        filter: '=',
        sites: '=',
        courseAccessSites: '<',
        component: '='
    },
    template: `
        <div class="table-filters">
            <form class="form form-filter" ng-if="vm.showFilter===true" ng-submit="vm.applyFilter()">
                <div class="fields">
                    <div class="row row-md">
                        <label class="label">{{ 'filter.Course name' | translate }}</label>
                        <div class="items">
                            <input ng-model="vm.filter.name" type="text" class="form-control">
                        </div>
                    </div>
                    <div class="row" ng-if="vm.component !== 'course'">
                        <label class="label">{{ 'filter.Site' | translate }}</label>
                        <div class="items">
                            <select class="form-control" ng-model="vm.filter.siteId"
                            ng-options="item.id as item.name for item in vm.sites">
                            <option ng-if="vm.SiteService.hasAccessToAllSites(vm.sites)" value=""
                            >{{ 'general.All sites' | translate }}</option>
                        </select>
                        </div>
                    </div>
                    <div class="row" ng-if="vm.component === 'course'">
                        <label class="label">{{ 'filter.Course Access' | translate }}</label>
                        <div class="items">
                            <div class="items">
                                <div
                                    ng-dropdown-multiselect=""
                                    options="vm.multiFilter.courseAccessSites.options"
                                    selected-model="vm.multiFilter.courseAccessSites.model"
                                    extra-settings="vm.multiFilter.courseAccessSites.settings"
                                    translation-texts="vm.filterTranslations"
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row row-separated">
                        <label class="label">{{ 'filter.Field name' | translate }}</label>
                        <div class="items">
                        <select class="form-control" ng-model="vm.filter.fieldId" ng-options="item.id as item.activeI18n.value for item in vm.fields">
                            <option value=""></option>
                        </select>
                        </div>
                    </div>
                    <div class="row row-md row-flex02">
                        <label class="label">{{ 'filter.Department' | translate }}</label>
                        <div class="items">
                            <div ng-dropdown-multiselect=""
                                options="vm.FilterService.departmentSelect.options"
                                selected-model="vm.FilterService.departmentSelect.models"
                                extra-settings="vm.FilterService.departmentSelect.settings"
                                events="vm.FilterService.departmentSelect.events"
                                translation-texts="vm.filterTranslations"
                            ></div>
                        </div>
                    </div>
                    <div class="row row-flex02">
                        <label class="label">{{ 'filter.Role' | translate }}</label>
                        <div class="items">
                            <div ng-dropdown-multiselect=""
                                options="vm.FilterService.roleSelect.options"
                                selected-model="vm.FilterService.roleSelect.models"
                                extra-settings="vm.FilterService.roleSelect.settings"
                                events="vm.FilterService.roleSelect.events"
                                translation-texts="vm.filterTranslations"
                            ></div>
                        </div>
                    </div>
                    <div class="row row-flex02">
                        <label class="label">{{ 'filter.Level' | translate }}</label>
                        <div class="items">
                            <div ng-dropdown-multiselect=""
                                options="vm.FilterService.levelSelect.options"
                                selected-model="vm.FilterService.levelSelect.models"
                                extra-settings="vm.FilterService.levelSelect.settings"
                                events="vm.FilterService.levelSelect.events"
                                translation-texts="vm.filterTranslations"
                            ></div>
                        </div>
                    </div>
                    <div class="row row-flex02" ng-if="vm.component == 'course' && vm.TokenService.isGuidanceModuleEnabled()">
                        <label class="label">{{ 'filter.Course type' | translate }}</label>
                        <div class="items">
                            <div
                                ng-dropdown-multiselect=""
                                options="vm.multiFilter.courseType.options"
                                selected-model="vm.multiFilter.courseType.model"
                                extra-settings="vm.multiFilter.courseType.settings"
                                translation-texts="vm.filterTranslations"
                                >
                            </div>
                        </div>
                    </div>
                    <div class="row row-flex02" ng-if="vm.component == 'course'">
                        <span class="label">{{ 'filter.Include archived courses' | translate }}</span>
                        <div class="items">
                            <label class="switch01">
                                <input name="switch" type="checkbox" ng-model="vm.filter.includeArchived">
                                <span>{{ 'general.Yes' | translate }}</span>
                            </label>
                        </div>
                    </div>
                    <div class="row row-flex02" ng-if="vm.component !== 'course'">
                        <span class="label">{{ 'filter.Only courses without targets' | translate }}</span>
                        <div class="items">
                            <label class="switch01">
                                <input name="switch" type="checkbox" ng-model="vm.filter.isWithoutTargetsOnly">
                                <span>{{ 'general.Yes' | translate }}</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="fields02" ng-if="vm.component !== 'course'">
                    <h2>{{ 'filter.Employees' | translate }}</h2>
                    <div class="row row-flex02 mr30">
                        <span class="label">{{ 'filter.Only employees without personal deadline' | translate }}</span>
                        <div class="items">
                            <label class="switch01">
                                <input type="checkbox"
                                    name="switch"
                                    ng-model="vm.filter.isWithoutDeadlineOnly">
                                <span>{{ 'general.Yes' | translate }}</span>
                            </label>
                        </div>
                    </div>
                    <div class="row row-flex02 mr20">
                        <span class="label">{{ 'filter.Include employees in started automated planning group' | translate }}</span>
                        <div class="items">
                            <label class="switch01">
                                <input type="checkbox" name="switch" checked="" ng-model="vm.includeApgEmployees">
                                <span>{{ 'general.Yes' | translate }}</span>
                            </label>
                        </div>
                    </div>
                </div>
                <ul class="actions01">
                    <li><input type="button" ng-click="vm.resetFilter()" class="btn discrete" value="{{ 'filter.Reset' | translate }}"></li>
                    <li><input type="submit" class="btn main" value="{{ 'filter.Filter' | translate }}"></li>
                </ul>
                <button type="submit" class="hidden" >{{ 'filter.Filter' | translate }}</button>
            </form>
        </div>
    `
})
export default class {
    constructor ($translate, lodash, CLASSIFIER_ENUM, SiteService, FilterService, TokenService) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.CLASSIFIER_ENUM = CLASSIFIER_ENUM;
        this.SiteService = SiteService;
        this.FilterService = FilterService;
        this.TokenService = TokenService;
    }

    $onInit () {
        this.FilterService.init(this.classifiers);
        this.filter = angular.copy(this.defaultFilter);
        this.filterTranslations = this.FilterService.getTranslations();
        this.fields = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.FIELD);
        this.departments = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.DEPARTMENT);
        this.roles = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.ROLE);
        this.levels = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.LEVEL);
        if (this.component === 'course') {
            this.initMultiFilter();
        }
    }

    initMultiFilter () {
        this.FilterService.init(this.classifiers);

        const siteOptions = this.courseAccessSites.map(site => {
            return {
                value: site.id,
                label: site.name
            };
        });

        const courseTypeOptions = [
            { value: 'course', label: this.$translate.instant('filter.Courses') },
            { value: 'guidance', label: this.$translate.instant('filter.Guidance') }
        ];

        this.multiFilter = {
            courseAccessSites: {
                model: this.lodash.clone(siteOptions),
                options: siteOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: true,
                    showUncheckAll: true,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                }
            },
            courseType: {
                model: this.lodash.clone(courseTypeOptions),
                options: courseTypeOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: false,
                    showUncheckAll: false,
                    smartButtonMaxItems: 2,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                }
            }
        };
        // this is used when filter is reset
        this.defaultMultiFilter = angular.copy(this.multiFilter);
    }

    applyFilter () {
        if (!this.filter.isWithoutTargetsOnly) {
            this.filter.isWithoutTargetsOnly = 0;
        }

        if (!this.filter.isWithoutDeadlineOnly) {
            this.filter.isWithoutDeadlineOnly = 0;
        }


        if (!this.filter.isArchived) {
            this.filter.isArchived = 0;
        }

        if (this.component === 'course') {
            this.filter.departmentIds = this.FilterService.departmentSelect.models
                .filter((department) => department.id !== null)
                .map((department) => department.id);

            this.filter.roleIds = this.FilterService.roleSelect.models
                .filter((role) => role.id !== null)
                .map(role => role.id);

            this.filter.levelIds = this.FilterService.levelSelect.models
                .filter((level) => level.id !== null)
                .map(level => level.id);

            const courseAccessSiteIds = !this.multiFilter.courseAccessSites.model.length ? [-1] : this.multiFilter.courseAccessSites.model.map(site => site.value);
            this.filter = this.lodash.assign(this.filter, { courseAccessSiteIds });

            // Course type filter (courses/guidance)
            if (this.TokenService.isGuidanceModuleEnabled() && this.multiFilter.courseType) {
                const selectedTypes = this.multiFilter.courseType.model.map(type => type.value);
                const includeCourses = selectedTypes.includes('course');
                const includeGuidance = selectedTypes.includes('guidance');

                if (includeCourses && !includeGuidance) {
                    this.filter.isGuidance = 0;
                }
                else if (!includeCourses && includeGuidance) {
                    this.filter.isGuidance = 1;
                }
                else {
                    delete this.filter.isGuidance;
                }
            }

            this.list.fetch({ expand: 'activeI18n,sites' }, this.filter).then(() => {
                // APG related counts and deadline are already cached in db
                // APG toggle switch result is assigned after fetching to avoid instant fields display on toggle
                this.filter.includeApgEmployees = this.includeApgEmployees;
                // hideCachedData is used to avoid instant fields change on toggle
                this.filter.hideCachedData = this.filter.isWithoutDeadlineOnly;
            });
        }
        else {
            this.filter['departmentIds[]'] = this.FilterService.departmentSelect.models
            .filter((department) => department.id !== null)
            .map((department) => department.id);

            this.filter['roleIds[]'] = this.FilterService.roleSelect.models
                .filter((role) => role.id !== null)
                .map(role => role.id);

            this.filter['levelIds[]'] = this.FilterService.levelSelect.models
                .filter((level) => level.id !== null)
                .map(level => level.id);

            this.list.fetch(this.filter).then(() => {
                // APG related counts and deadline are already cached in db
                // APG toggle switch result is assigned after fetching to avoid instant fields display on toggle
                this.filter.includeApgEmployees = this.includeApgEmployees;
                // hideCachedData is used to avoid instant fields change on toggle
                this.filter.hideCachedData = this.filter.isWithoutDeadlineOnly;
            });
        }
    }

    resetFilter () {
        if (this.component === 'course') {
            this.multiFilter = angular.copy(this.defaultMultiFilter);
        }
        this.filter = angular.copy(this.defaultFilter);
        this.includeApgEmployees = 0;
        this.applyFilter();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/filter/courses/index.js